
import { Component, mixins } from 'nuxt-property-decorator';
import { TextBlockModel } from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../ContentBlockMixin';
import ContentBlockButton from './ContentBlockButton.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockButton,
  },
})
export default class TextBlock extends mixins(ContentBlockMixin<TextBlockModel>) {}
